import {
  sagaListSuccess,
  sagaUpdateSuccess,
  sagaCreateSuccess
} from "../actions/ActionTypes";
import moment from "moment";
import { remove } from "lodash";
import R from "ramda";

const PRAYERS = "prayers";
const PRAYER = "prayer";

const initialState = {
  list: [],
  currentPrayer: {},
  showPrayerModal: false
};

const transformToCalendarDates = prayer => {
  const start = new Date(prayer.prayer_date);
  const end = moment(start).add(1, "minute");
  return Object.assign(prayer, {
    title: prayer.description,
    allDay: true,
    start,
    end
  });
};

export default function prayers(state = initialState, action = {}) {
  switch (action.type) {
    case "HIDE_PRAYER_MODAL":
      return { ...state, showPrayerModal: false };
    case "NEW_PRAYER":
      return { ...state, showPrayerModal: true, currentPrayer: {} };
    case "EDIT_PRAYER":
      return {
        ...state,
        showPrayerModal: true,
        currentPrayer: action.data
      };
    case sagaListSuccess(PRAYERS):
      const prayers = action.data.data;
      const _prayers = R.map(transformToCalendarDates, prayers);
      return { ...state, list: _prayers };
    case sagaCreateSuccess(PRAYER):
      const current = action.data.data;
      state.list.push(transformToCalendarDates(current));
      return { ...state, currentPrayer: current };
    case sagaUpdateSuccess(PRAYER):
      let updatedPrayer = action.data.data;
      remove(state.list, x => x.id === updatedPrayer.id);
      state.list.push(transformToCalendarDates(updatedPrayer));
      return {
        ...state,
        currentPrayer: action.data.data
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/prayers.js